import { Api, AuthToken, MenuItem, Navigation } from "@mcleod/core";
import { CommonDialogs } from "../CommonDialogs";
import { DataSource } from "@mcleod/components";

export class ImagingMenuLauncher {
    private dbaliasMap = new Map<string, string>();
    private dbaliasMapLoaded = false;

    async navigateTo(navItem: MenuItem, newTab: boolean, windowDecorators: boolean = false) {
        const payLoad: any = AuthToken.getTokenClaims();
        const cid: string = payLoad.company_id;

        if (!this.dbaliasMapLoaded) {
            const sourceDidbalias: DataSource = new DataSource({ id: "sourceDidbalias", url: "imaging/AccessAdmin/didbalias_menu" });
            await sourceDidbalias.search({ didb_company: cid });
            const rows: any[] = sourceDidbalias.data;
            for (const row of rows) {
                const compid = row._data.didb_company;
                const dba = row._data.didb_dbalias;
                this.dbaliasMap.set(compid, dba);
                this.dbaliasMapLoaded = true;
            }
        }
        const dbalias: string = this.dbaliasMap.get(cid);

        if (navItem.path == "dp-url") {
            const mainUrl: string = dbalias + navItem.params;
            await Navigation.navigateTo(mainUrl, { newTab: true });
        } else if (navItem.path.includes("imaging/")) {
            if (await this.isAccessAllowed(navItem.path)) {
                if (navItem.path == "imaging/AccessAdmin/AccessAdmin") {
                    if (dbalias == "dta")
                        Navigation.navigateTo(navItem.path || navItem[""], { newTab: newTab, windowDecorators: windowDecorators });
                    else
                        CommonDialogs.showMessage("Access Admin can only run from dta/TMS", "Document Power");
                } else {
                    Navigation.navigateTo(navItem.path || navItem[""], { newTab: newTab, windowDecorators: windowDecorators });
                }
            } else {
                CommonDialogs.showMessage("You don't have access to this module...", "Document Power");
            }
        }
    }

    async isAccessAllowed(module: string): Promise<boolean> {
        let st: boolean = false;
        await Api.post("imaging-services/imglicserver", { action: "check", module: module }).then(response => {
            if (response) {
                st = response.data[0].licensed >= 1 && response.data[0].licensed <= 3 ? true : false;
            } else {
                CommonDialogs.showMessage("Failed to check module...", "Document Power");
            }
        });
        return st;
    }
}
